import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
  state: {
    categoriaSelecionadas: []
  },
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/cadastro/index.js